module.exports = __webpack_public_path__ + "static/media/frame-about.1581de09.png";